export const actionsReserveVehicle = {
  CHANGE_VISIBILITY ({commit}, payload) {
    commit('CHANGE_VISIBILITY', payload)
  }
}

export default {}



// WEBPACK FOOTER //
// ./src/store/reserveVehicle/actions.js